/*
 * @Author: 冯杰
 * @Date: 2021-10-28 16:21:57
 * @LastEditTime: 2021-10-29 10:34:33
 * @FileName: 文件名
 */
import TablePage from '@/found/components/table_page';
import Modal from '@/found/components/modal';

export default {
  name: 'DealerStatisical',
  extends: TablePage,
  props: {
    customerCode: String,
  },
  data() {
    return {
      requestUrl: '/cps/v1/web/participatorReward/findByConditions',
      requestType: 'GET',
      params: {
        code: this.customerCode || '',
      },
    };
  },
  components: {
    Modal,
  },

  methods: {
    // 按钮点击事件
    modalClick({ val, row }) {},
  },
  created() {
    // 重写获取配置信息
    this.getConfigList('protocol');
  },
};
